import {
	OrderInputLike,
	OrderItemInputLike,
	OrderItemOptionInputLike,
} from "../types";
import { $isOrderUnpaid, BASE_ORDERS_GROUP_VALUE } from "./_internals";
import { $addOrderToOrderGroupCalculation } from "./calculate-order";

export const calculateOrderGroup = <
	TOrder extends OrderInputLike = OrderInputLike,
	TOrderItem extends OrderItemInputLike = OrderItemInputLike,
	TOrderItemOption extends OrderItemOptionInputLike = OrderItemOptionInputLike,
>(
	orders: OrderInputLike<TOrder, TOrderItem, TOrderItemOption>[],
) => {
	return orders.reduce(
		(pre, cur) => {
			const isOrderUnpaid = $isOrderUnpaid(cur);
			const isOrderPaid = !isOrderUnpaid;

			return {
				all: $addOrderToOrderGroupCalculation(pre.all, cur),
				paid: isOrderPaid
					? $addOrderToOrderGroupCalculation(pre.paid, cur)
					: pre.paid,
				unpaid: isOrderUnpaid
					? $addOrderToOrderGroupCalculation(pre.unpaid, cur)
					: pre.unpaid,
			};
		},
		{
			all: BASE_ORDERS_GROUP_VALUE,
			paid: BASE_ORDERS_GROUP_VALUE,
			unpaid: BASE_ORDERS_GROUP_VALUE,
		},
	);
};
